<template>
    <div :class="getCSSClass('slideshow-container')">
        <div :class="getCSSClass('slideshow-prev-button-container')">
            <button v-on:click="previousImage"
                    :disabled="!hasPrevious"
                    :class="getCSSClass('slideshow-prev-button')"
                    v-html="icon('arrow-prev')"
            ></button>
        </div>
        <div :class="getCSSClass('slideshow-image-container')">
            <div  :class="getCSSClass('slideshow-image-name')" v-html="currentImageName"></div>
            <div  :class="getCSSClass('slideshow-image-image-container')">
                <img :class="getCSSClass('slideshow-image')"
                     style="transition: opacity 100ms ease-in-out"
                     :ref="'image'"
                     :src="currentImageLink">
            </div>
            <div  :class="getCSSClass('slideshow-image-description')" v-html="currentImageDescription"></div>
        </div>
        <div :class="getCSSClass('slideshow-next-button-container')">
            <button v-on:click="nextImage"
                    :disabled="!hasNext"
                    :class="getCSSClass('slideshow-next-button')"
                    v-html="icon('arrow-next')"
            ></button>
        </div>
        <button v-if="showCloseButton"
                :class="getCSSClass('slideshow-close-button')"
                v-on:click="$emit('close')"
                v-html="icon('close')"></button>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            files: {type: Array},
            startingIndex: {type: Number, default: 0},
            showCloseButton: {type: Boolean, default: true}
        },
        data: function () {
            return {
                index: 0
            }
        },
        mounted() {
            this.index = this.startingIndex;
            window.addEventListener('keyup', this.keyHandler);
        },
        destroyed() {
            window.removeEventListener('keyup', this.keyHandler);
        },
        methods: {
            keyHandler: function(event) {
                if (event.key == 'ArrowLeft') {
                    return this.previousImage();
                }
                if (event.key == 'ArrowRight') {
                    return this.nextImage()
                }
                if (event.key == 'Escape') {
                    this.$emit('close');
                    return;
                }
            },
            previousImage: function() {
                if (this.hasPrevious) {
                    this.$refs['image'].style.opacity = 0;
                    this.index--;
                    window.setTimeout(() => {
                        this.$refs['image'].style.opacity = 1;
                    }, 200);
                }
            },
            nextImage: function() {
                if (this.hasNext) {
                    this.$refs['image'].style.opacity = 0;
                    this.index++;
                    window.setTimeout(() => {
                        this.$refs['image'].style.opacity = 1;
                    }, 200);
                }
            }
        },
        computed: {
            currentImageName: function() {
                if (!this.files[this.index]) {
                    return null;
                }
                return this.files[this.index].name;
            },
            currentImageDescription: function() {
                if (!this.files[this.index]) {
                    return null;
                }
                return this.files[this.index].description;
            },
            currentImageLink: function() {
                if (!this.files[this.index]) {
                    return null;
                }
                return this.files[this.index].link;
            },
            hasPrevious: function() {
                return this.index > 0;
            },
            hasNext: function() {
                return this.index < this.files.length - 1;
            }
        },
        watch: {}

    }
</script>
